import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {FeeSnapshot} from '@gatewee/types/fee';
import {Transaction} from '@gatewee/types/transaction';
import {UtilsModule} from '@gatewee/utils';
import {TuiTabs} from '@taiga-ui/kit';
import {GateweeFeeSnapshotTableComponent} from '../gatewee-fee-snapshot-table/gatewee-fee-snapshot-table.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

@Component({
  selector: 'gatewee-transactions-fees-tabs',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    UtilsModule,
    ...TuiTabs,
    GateweeIconComponent,
    GateweeFeeSnapshotTableComponent,
  ],
  templateUrl: './gatewee-transactions-fees-tabs.component.html',
  styleUrls: ['./gatewee-transactions-fees-tabs.component.css'],
})
export class GateweeTransactionsFeesTabsComponent {
  /** Lines shown in the transactions table. */
  @Input() transactions: Transaction[] | null | undefined = [];

  /** Captured fees (domain + recipient lines). */
  @Input() feeSnapshot: FeeSnapshot | null | undefined;

  /** Currency for transaction amounts. */
  @Input() currencyCode = 'BRL';

  /** 0 = transactions, 1 = fees (TuiTabs activeItemIndex). */
  activeItemIndex = 0;

  get transactionsList(): Transaction[] {
    return Array.isArray(this.transactions) ? this.transactions : [];
  }

  /** Total raw lines in the snapshot (used for tab badge and enablement). */
  get feeLineCount(): number {
    const s = this.feeSnapshot;
    if (!s) {
      return 0;
    }
    const d = Array.isArray(s.domain) ? s.domain.length : 0;
    const r = Array.isArray(s.recipient) ? s.recipient.length : 0;
    return d + r;
  }

  /** Returns gw-* Tailwind classes for transaction status badges. */
  getStatusBadgeClass(status: string): string {
    const s = (status || '').toLowerCase();
    if (
      [
        'paid',
        'confirmed',
        'success',
        'cashed_out',
        'active',
        'fixed',
      ].includes(s)
    ) {
      return 'gw-bg-status-positive-pale gw-text-text-primary';
    }
    if (['failed', 'canceled', 'rejected', 'expired', 'past_due'].includes(s)) {
      return 'gw-bg-status-negative-pale gw-text-text-primary';
    }
    if (
      [
        'pending',
        'pending_generation',
        'in_dispute',
        'pending_refund',
      ].includes(s)
    ) {
      return 'gw-bg-status-warning-pale gw-text-text-primary';
    }
    if (['refunded', 'variable'].includes(s)) {
      return 'gw-bg-status-neutral gw-text-text-primary';
    }
    return 'gw-bg-status-info-pale gw-text-text-primary';
  }
}
